import { render, staticRenderFns } from "./Internal.vue?vue&type=template&id=5bfdc778"
import script from "./Internal.vue?vue&type=script&lang=ts"
export * from "./Internal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports